module.exports = __webpack_public_path__ + "static/media/ishan.1f39d798.jpg";